import React from 'react';
import * as Icons from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { assets, socials, contactInfo } from '../mock';

const Footer = () => {
  const { t } = useLanguage();
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  const links = [
    ['home', t.nav.home], ['about', t.nav.about], ['services', t.nav.services],
    ['gallery', t.nav.gallery], ['packages', t.nav.packages], ['contact', t.nav.contact],
  ];

  return (
    <footer className="bg-[#070707] border-t border-[#e6b83f]/15 pt-16 pb-8 px-5">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <img src={assets.logo} alt="LAJO" className="h-16 w-auto object-contain" />
            <p className="font-serif-el italic text-[#c2bbaa] mt-5 max-w-xs leading-relaxed">{t.footer.tagline}</p>
          </div>

          <div>
            <h4 className="font-sans-el text-[13px] tracking-[0.25em] uppercase text-[#e6b83f] mb-5">{t.footer.links}</h4>
            <ul className="space-y-3">
              {links.map(([id, label]) => (
                <li key={id}>
                  <button onClick={() => go(id)} className="font-sans-el text-[15px] text-[#c2bbaa] hover:text-[#f5deA0] transition-colors">
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-sans-el text-[13px] tracking-[0.25em] uppercase text-[#e6b83f] mb-5">{t.footer.follow}</h4>
            <div className="flex flex-wrap gap-3">
              {socials.map((s) => {
                const Icon = Icons[s.icon] || Icons.Music;
                return (
                  <a
                    key={s.name}
                    href={s.url}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={s.name}
                    className="w-11 h-11 rounded-sm border border-[#e6b83f]/30 flex items-center justify-center text-[#cfc8b8] hover:bg-[#e6b83f] hover:text-[#14120d] hover:border-[#e6b83f] transition-all"
                  >
                    <Icon size={18} />
                  </a>
                );
              })}
            </div>
            <a href={`tel:${contactInfo.phoneRaw}`} className="font-deco text-lg text-[#f5deA0] mt-6 inline-block hover:text-[#f2e6c9] transition-colors">
              {contactInfo.phone}
            </a>
          </div>
        </div>

        <div className="gold-line my-10" />
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-sans-el text-[13px] text-[#948d7c]">
            © {new Date().getFullYear()} Latin American Jazz Orchestra. {t.footer.rights}
          </p>
          <p className="font-sans-el text-[13px] text-[#948d7c]">Ciudad de México</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
